const messagesSpecific = {
  en: {
    all: 'All',
    filters: 'Filters',
    clearFilters: 'Clear filters',
    applyFilters: 'Apply filter',
    showFilters: 'Show filters',
    closeFilters: 'Close filters',
    destinations: 'Destinations',
    interests: 'Interests',
    destination: 'Destination',
    brands: 'Brands',
    types: 'Types',
    starRating: 'Star rating',
    back: 'Dashboard',
    services: 'Facilities/Services',
    sortBy: 'Sort by',
    recommendedFirst: 'Sort by recommended',
    lowFirst: 'Price - lowest first',
    highFirst: 'Price - highest first',
    lowPointsFirst: 'Points - lowest first',
    highPointsFirst: 'Points - highest first',
    noResults: 'No results, modify filter',
    unavailableSeparator: 'Not available for selected dates',
    bookNow: 'Book Now',
    from: 'from',
    perUnit: 'per unit',
    error: 'Error',
    holidayTypeFilter: 'Type of holidays',
    property: 'Property',
    discoverMore: 'Discover more',
    confirm: 'Confirm',
    canceled: 'Canceled',
    notCanceled: 'Active',
    formSubmitSuccess: 'You have successfully submitted the form.',
    loadMore: 'Load more',
    results: 'Results: ',
    allDestinations: 'All destinations',
    allBrands: 'All brands',
    allInterests: 'All interests',
    error403: {
      title: '403',
      text: 'You have to be logged in to access this page.',
      goHome: 'Home',
    },
    searchApp: {
      placeholder: 'Search properties, offers, ideas ...',
      suggestionsTitle: 'Find your perfect getaway',
      showFilters: 'Show filters',
      clearFilters: 'Clear all',
      applyFilters: 'Apply filter',
      cancelFilters: 'Cancel',
      resultType: {
        offer: 'Special offer',
      },
      filters: {
        propertyType: 'Property type',
        destination: 'Destination',
        brand: 'Brand',
      },
      noResults: 'There are no results for this query.',
      showing: 'Showing',
      outOf: 'out of',
      results: 'results',
    },
    focusedSearch: {
      placeholder: 'Find Your Stay',
      showAll: 'Show all',
      properties: 'Properties',
      specialOffers: 'Special Offers',
      searchFor: 'Search for:',
    },
    bookingWidget: {
      planYourStay: 'Plan your stay',
      whereAreYouGoing: 'Where are you going?',
      noResultsTitle: 'There are no results for this keyword.',
      noResultsMessage: 'Select one of the following or enter a different keyword.',
    },
    propertyTypes: {
      hotels: 'Hotels',
      resorts: 'Resorts',
      camping: 'Campsites',
    },
    campingTypes: {
      pitches: 'Pitches',
      'mobile-homes': 'Mobile Homes',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Where do you want to go?',
      stepTitle2: 'Which hotel, resort or campsite?',
      stepTitle3: 'Select dates',
      stepTitle4: 'Select number of guests',
      checkRatesButton: 'Check rates',
      backLabel: 'Back',
      closeButtonLabel: 'Close',
      allDestinations: 'Select all destinations',
      allProperties: 'Select all in ',
      allPropertiesInDestination: 'All properties in current destination',
      hotelsResorts: 'Hotels and resorts',
      campsites: 'Campsites',
      noProperties: 'No properties to show.',
      serachOverview: 'Search overview',
      destination: 'Destination:',
      edit: 'Edit',
      nights: 'nights',
    },
    offers: {
      nrOfAvailable: 'offers available for your search',
      titleNoAvailable: 'There are no special offers available for your search.',
      titleNoAvailableVariants: 'The special offer has expired. Check out our active offers below',
      subtitleNoAvailable: 'We recommend the following alternatives:',
      recommendedOffers: 'Recommended special offers',
      minimumStayPrefix: 'Minimum number of nights:',
      period: 'Period:',
      filter: 'Filter offers',
      allHolidays: 'All holidays',
      allProperties: 'All properties',
      from: 'From',
      upTo: 'Up to',
      recommended: 'Recommended For You',
      popularNow: 'Popular Right Now',
      allOffers: 'All offers',
    },
    newsletter: {
      firstName: 'First name *',
      lastName: 'Last name *',
      titleAll: 'Mr./Mrs.',
      titleMr: 'Mr.',
      titleMrs: 'Mrs.',
      email: 'Email *',
      gender: 'Title *',
      birthDate: 'Date of birth',
      country: 'Country',
      brands: 'Types of accomodation *',
      language: 'Newsletter language *',
      consent: 'Keep me updated on news, offers and exclusive member deals.',
      info: 'We respect your privacy and are committed to protecting your personal data. ' +
        'For more information about the protection of your personal data, please see our {privacyPolicy}.',
      privacyPolicy: 'Privacy policy',
      register: 'Register',
      submitSuccess: 'Form submitted successfully.',
    },
    contact: {
      title: 'Contact form',
      subtitle: 'You can also sen us your message or question via the contact form. We will answer as soon as possible.',
      name: 'Name and Surname*',
      email: 'E-mail address*',
      subject: 'Subject*',
      property: 'Property',
      message: 'Your message',
      send: 'Send',
      requiredFields: '* Required fields',
      submitSuccess: 'Form submitted successfully.',
    },
    interestsTab: {
      title: 'My Interests',
      brand: 'Brand',
      destination: 'Destination',
      holiday: 'Type of holiday and interests',
      campsite: 'Campsite',
      leadText: 'Please fill in your travel interests.',
      dataProtection: '<p>We respect your privacy and are committed to protecting your personal data. We collect different types of personal data about you, depending on your relationship with us and the services you use. In any case, we collect and process your personal data for legitimate purposes and on a valid legal basis.</p><p>For more information about the protection of your personal data, please see our <a href="/privacy-policy/">Privacy Notice</a>.</p>',
      updateSuccess: 'You have successfully updated your interests.',
    },
    preferencesTab: {
      title: 'Preferences',
      leadText: 'Kindly note that not all options are universally available across all properties and at all times.',
      bedding: 'Pillows and bedding preferences',
      notAvailableInCampsites: '* Not available in campsites.',
      rooms: 'Room preferences',
      roomsExtra: 'Upon availability, based on the hotel and room type you have booked.',
      services: 'Additional services',
      servicesExtra: 'Free of charge, available only in specific properties.',
      food: 'Food preferences',
      childEquipment: 'Additional baby and children’s equipment (Free of charge)',
      pickupAtReception: '*Pick up at the hotel reception.',
      typeHere: 'Type here',
      updateSuccess: 'You have successfully updated your stay preferences.',
    },
    extraServices: {
      title: 'Additional services (extra charge)',
      text: 'Do you have any additional requests for the hotel?',
      footer: 'e.g. Balloons, cake, flowers or drinks in the room',
    },
    preArrivalForm: {

    },
    activity: {
      activity: 'Activity',
      youHave: 'you have: ',
      expiration: 'Expiration DATE.. do we have this?',
      transferPoints: 'transfer points',
      missingPoints: 'obtain missing points',
      pointsActivity: 'Points Activity',
      date: 'Date',
      source: 'Source',
      points: 'Points',
      noActivity: 'Currently, there is no points activity.',
      title: 'Points activity',
      transactionTypes: ['Stay', 'Survey', 'Registration', 'Contact Edited', 'Points Transfer', 'Other', 'Points Claim', 'Points Redemption', 'Expired', 'Additional consumption'],
    },
    activityPointsCommon: {
      requiredFields: '* These fields are required',
      send: 'Send',
    },
    awards: {
      all: 'All',
      recommended: 'Recommended rewards',
      title: 'MaiStar Rewards',
      recommendedTitle: 'Recommended awards for your next stay',
      points: 'points',
      discoverMore: 'Discover more',
      available: 'Available',
      unavailable: 'Unavailable',
      noReservations: 'You have no upcoming reservations. It is time for your new holidays.',
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome,',
      displayName: 'Display Name',
      level: 'Level',
      editprofile: 'Edit profile',
      membershipNumber: 'Membership Number',
      memberSince: 'Member Since',
      viewPoints: 'View points activity',
      viewBookings: 'view all bookings',
      viewProperties: 'view all properties',
      enlargeQr: 'Enlarge QR code',
      youHave: 'You have',
      points: 'points',
      myBookings: 'My Bookings',
      maiFamilyProperties: 'Recommended properties',
      maistarRewards: 'MaiStar Rewards',
      rewards: 'Rewards',
      viewRewards: 'view all rewards',
      noRewards: 'no rewards',
      moreAboutStatus: 'More about you status',
      scrollDown: 'Scroll down',
      expiresOn: 'Expires on:',
      personalDetails: 'Personal details',
      addToAppleWallet: 'Add to Apple Wallet',
      addToGoogleWallet: 'Add to Google Wallet',
    },
    obtainPoints: {
      mainTitle: 'Obtain missing points',
      title: 'Missing points for a booking?<br>Please submit a missing points request.',
      formTitle: 'Please fill out this form with your data',
      property: 'Property *',
      arrivalDate: 'Arrival date *',
      departureDate: 'Departure date *',
      pointsAwardedTime: 'Points will be awarded 72 hours after checkout.',
      bookingReferenceNumber: 'Booking reference number *',
      invoiceAmount: 'Invoice amount *',
      comment: 'Other comments & requests',
      success: 'Your request was submitted successfully.',
    },
    transferPoints: {
      mainTitle: 'Transfer points',
      title: 'How many points would you like to transfer?',
      formTitle: 'Account to which you would like to transfer points',
      receiverFirstName: 'First name *',
      receiverLastName: 'Last name *',
      receiverEmail: 'E-mail address *',
      receiverLoyaltyId: 'Loyalty card number *',
      allPointsSelection: 'All points',
      otherAmountSelection: 'Other amount',
      pointsAvailable: 'Points available: ',
      points2Transfer: 'Points to transfer: ',
      success: 'Your request was submitted successfully.',
    },
    activation: {
      success: [
        'If we found the email in database we sent you the link.',
        'It appears you already have an account. Please log in.',
      ],
    },
    reservations: {
      title: 'Bookings',
      property: 'Property',
      check: 'Check in / Check out',
      rate: 'Rate',
      status: 'Status',
      checkRates: 'Check rates',
      noReservations: 'You have no upcoming reservations.',
      newHolidays: 'It is time for your new holidays.',
      noPropertyTitle: 'No property name found. PhobsID: ',
      bookingRef: 'Booking ref:',
      memberRate: 'Total member rate',
      discoverExperiences: 'Discover new experiences',
      activeReservations: 'Active reservations',
      pastReservations: 'Past reservations',
    },
  },
  hr: {
    all: 'Sve',
    filters: 'Filtri',
    clearFilters: 'Izbriši filtre',
    applyFilters: 'Primijeni filtar',
    showFilters: 'Prikaži filtre',
    closeFilters: 'Zatvori filtre',
    destinations: 'Odredišta',
    interests: 'Interesi',
    destination: 'Odredište',
    brands: 'Brendovi',
    types: 'Vrste',
    starRating: 'Broj zvjezdica',
    back: 'Nadzorna ploča',
    services: 'Sadržaji/usluge',
    sortBy: 'Razvrstaj prema',
    recommendedFirst: 'Razvrstaj prema preporukama',
    lowFirst: 'Cijena - od najniže',
    highFirst: 'Cijena - od najviše',
    lowPointsFirst: 'Bodovi - od najmanjeg broja',
    highPointsFirst: 'Bodovi - od najvećeg broja',
    noResults: 'Nema rezultata, promijenite filtar',
    unavailableSeparator: 'Nije dostupno za odabrane datume',
    bookNow: 'Rezerviraj sada',
    from: 'od',
    perUnit: 'po jedinici',
    error: 'Pogreška',
    holidayTypeFilter: 'Vrsta odmora',
    property: 'Objekt',
    discoverMore: 'Otkrijte više',
    confirm: 'Potvrdi',
    canceled: 'Otkazano',
    notCanceled: 'Aktivno',
    formSubmitSuccess: 'Uspješno ste poslali obrazac.',
    loadMore: 'Učitaj više',
    results: 'Rezultati: ',
    allDestinations: 'Sve destinacije',
    allBrands: 'Svi brendovi',
    allInterests: 'Svi interesi',
    error403: {
      title: '403',
      text: 'Morate biti prijavljeni da biste pristupili ovoj stranici.',
      goHome: 'Početna',
    },
    searchApp: {
      placeholder: 'Pretražujte objekte, ponude, ideje ...',
      suggestionsTitle: 'Pronađite svoj savršeni odmor',
      showFilters: 'Prikaži filtre',
      clearFilters: 'Poništi sve',
      applyFilters: 'Primijeni filtar',
      cancelFilters: 'Odustani',
      resultType: {
        offer: 'Posebna ponuda',
      },
      filters: {
        propertyType: 'Vrsta objekta',
        destination: 'Odredište',
        brand: 'Marka',
      },
      noResults: 'Nema rezultata za ovaj upit.',
      showing: 'Prikazuje se',
      outOf: 'od',
      results: 'rezultata',
    },
    focusedSearch: {
      placeholder: 'Pronađite svoj boravak',
      showAll: 'Prikaži sve',
      properties: 'Smještaj',
      specialOffers: 'Posebne ponude',
      searchFor: 'Traži:',
    },
    bookingWidget: {
      planYourStay: ' Planirajte svoj boravak',
      whereAreYouGoing: 'Kamo putujete?',
      noResultsTitle: 'Nema rezultata za ovu ključnu riječ.',
      noResultsMessage: 'Odaberite jednu od sljedećih opcija ili unesite drugu ključnu riječ.',
    },
    propertyTypes: {
      hotels: 'Hoteli',
      resorts: 'Resorti',
      camping: 'Camping',
    },
    campingTypes: {
      pitches: 'Parcele',
      'mobile-homes': 'Mobilne kućice',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Gdje želite ići?',
      stepTitle2: 'Koji hotel, resort ili kamp?',
      stepTitle3: 'Odaberite datume',
      stepTitle4: 'Odaberite broj gostiju',
      checkRatesButton: 'Provjerite cijene',
      backLabel: 'Natrag',
      closeButtonLabel: 'Zatvori',
      allDestinations: 'Odaberi sve destinacije',
      allProperties: 'Odaberite sve objekte na destinaciji',
      allPropertiesInDestination: 'Svi objekti u odabranoj destinaciji',
      hotelsResorts: 'Hoteli i resorti',
      campsites: 'Kampovi',
      noProperties: 'Nema objekata za prikaz.',
      serachOverview: 'Pregled pretrage',
      destination: 'Odredište:',
      edit: 'Uredi',
      nights: 'noći',
    },
    offers: {
      nrOfAvailable: 'ponude/a dostupne/o za pretragu',
      titleNoAvailable: 'U okviru vašeg pretraživanja nije dostupna nijedna posebna ponuda.',
      titleNoAvailableVariants: 'Istekla je posebna ponuda. Pogledajte naše aktivne ponude u nastavku',
      subtitleNoAvailable: 'Preporučujemo sljedeće ostale mogućnosti:',
      recommendedOffers: 'Preporučene posebne ponude',
      minimumStayPrefix: 'Minimalni broj noćenja:',
      period: 'Period:',
      filter: 'Filter ponuda',
      allHolidays: 'Sve vrste odmora',
      allProperties: 'Svi objekti',
      from: 'Od',
      upTo: 'Do',
      recommended: 'Preporučeno za vas',
      popularNow: 'Popularno sada',
      allOffers: 'Sve ponude',
    },
    newsletter: {
      firstName: 'Ime *',
      lastName: 'Prezime *',
      titleAll: 'Gospodin/gospođa',
      titleMr: 'Gospodin',
      titleMrs: 'Gospođa',
      email: 'E-pošta *',
      gender: 'Titula *',
      birthDate: 'Datum rođenja',
      country: 'Država',
      brands: 'Vrste smještaja *',
      language: 'Jezik biltena *',
      consent: 'Želim primati obavijesti o novostima, ponudama i ekskluzivnim ponudama za članove.',
      info: 'Poštujemo vašu privatnost i obvezujemo se na zaštitu vaših osobnih podataka. ' +
        '        Više informacija o zaštiti osobnih podataka potražite u našoj {IzjaviOPrivatnosti}.',
      privacyPolicy: 'izjava o privatnosti',
      register: 'Registracija',
      submitSuccess: 'Obrazac je uspješno poslan.',
    },
    contact: {
      title: 'Obrazac za kontakt',
      subtitle: 'Također nam možete poslati poruku ili pitanje putem obrasca za kontakt. Odgovorit ćemo vam u najkraćem mogućem roku.',
      name: 'Ime i prezime*',
      email: 'Adresa e-pošte*',
      subject: 'Predmet*',
      property: 'Objekt',
      message: 'Vaša poruka',
      send: 'Pošalji',
      requiredFields: '* Obavezna polja',
      submitSuccess: 'Obrazac je uspješno poslan.',
    },
    interestsTab: {
      title: 'Moji interesi',
      brand: 'Brend',
      destination: 'Odredište',
      holiday: 'Vrsta odmora i interesi',
      campsite: 'Kamp',
      leadText: 'Označite svoje interese tijekom putovanja',
      dataProtection: '<p>Poštujemo vašu privatnost i obvezujemo se na zaštitu vaših osobnih podataka. Prikupljamo različite vrste vaših osobnih podataka ovisno o odnosu koji imate s nama i uslugama koje upotrebljavate. U svakom slučaju vaše osobne podatke prikupljamo i obrađujemo sa svrhom i prema zakonu.</p><p>Više informacija o zaštiti osobnih podataka potražite u našoj <a href="/hr/politika-privatnosti/">Izjavi o privatnosti</a>.</p>',
      updateSuccess: 'Uspješno ste ažurirali svoje interese.',
    },
    preferencesTab: {
      title: 'Preferencije',
      leadText: 'Napominjemo da nisu sve opcije dostupne u svakom objektu i u svakom trenutku.',
      bedding: 'Odabir preferencija za jastuk i posteljinu',
      notAvailableInCampsites: '* Nije dostupno u kampovima.',
      rooms: 'Odabir preferencija za sobu',
      roomsExtra: 'Ovisno o raspoloživosti, na temelju vašeg odabira hotela i sobe.',
      services: 'Dodatne usluge',
      servicesExtra: 'Bez nadoplate, dostupno samo u određenim objektima.',
      food: 'Odabir preferencija za hranu ',
      childEquipment: 'Dodatna oprema za bebe i djecu (besplatno)',
      pickupAtReception: '* Preuzimanje na recepciji hotela.',
      typeHere: 'upišite ovdje',
      updateSuccess: 'Uspješno ste ažurirali svoje preferencije.',
    },
    extraServices: {
      title: 'Dodatne usluge (uz naplatu) ',
      text: 'Imate li dodatnih zahtjeva za hotel?',
      footer: 'npr. baloni, torta, cvijeće ili piće u sobi',
    },
    activity: {
      activity: 'Aktivnost',
      youHave: 'imate:',
      expiration: 'DATUM isteka... imamo li ovo?',
      transferPoints: 'prenesite bodove',
      missingPoints: 'prikupite bodove koji nedostaju',
      pointsActivity: 'Aktivirani bodovi',
      date: 'Datum',
      source: 'Izvor',
      points: 'Bodovi',
      noActivity: 'Trenutačno nema aktiviranih bodova.',
      title: 'Aktivirani bodovi',
      transactionTypes: ['Boravak', 'Anketa', 'Registracija', 'Kontakt uređen', 'Prijenos bodova', 'Ostalo', 'Prikupljanje bodova', 'Iskorištavanje bodova', 'Isteklo', 'Vanpansionska potrošnja'],
    },
    activityPointsCommon: {
      requiredFields: '* Ova su polja obavezna',
      send: 'Pošalji',
    },
    awards: {
      all: 'Sve',
      recommended: 'Preporučene nagrade',
      title: 'MaiStar Rewards',
      recommendedTitle: 'Preporučene nagrade za vaš sljedeći boravak',
      points: 'bodovi',
      discoverMore: 'Otkrijte više',
      available: 'Dostupno',
      unavailable: 'Nedostupno',
      noReservations: 'Nemate nadolazećih rezervacija. Vrijeme je za vaš novi odmor.',
    },
    dashboard: {
      title: 'Nadzorna ploča',
      welcome: 'Dobro došli,',
      displayName: 'Prikaži ime i prezime',
      level: 'Razina',
      editprofile: 'Uredi profil',
      membershipNumber: 'Broj članstva',
      memberSince: 'Član od',
      viewPoints: 'Prikaži aktivirane bodove',
      viewBookings: 'prikaži sve rezervacije',
      viewProperties: 'view all properties',
      enlargeQr: 'Povećaj QR kod',
      youHave: 'Imate',
      points: 'bodovi',
      myBookings: 'Moje rezervacije',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Nagrade',
      maistarRewards: 'MaiStar nagrade',
      viewRewards: 'prikaži sve nagrade',
      noRewards: 'nema nagrada',
      moreAboutStatus: 'Više o vašem statusu',
      scrollDown: 'Pomaknite se prema dolje',
      expiresOn: 'Datum isteka:',
      personalDetails: 'Osobni podaci',
      addToAppleWallet: 'Dodaj u Apple Novčanik',
      addToGoogleWallet: 'Dodaj u Google Novčanik',
    },
    obtainPoints: {
      mainTitle: 'Prikupite bodove koji nedostaju',
      title: 'Nedostaje vam bodova za rezervaciju?<br>Pošaljite zahtjev za bodove koji nedostaju.',
      formTitle: 'Ispunite ovaj obrazac svojim podacima',
      property: 'Objekt *',
      arrivalDate: 'Datum dolaska *',
      departureDate: 'Datum polaska *',
      pointsAwardedTime: 'Bodovi će biti dodani 72 sata nakon odjave.',
      bookingReferenceNumber: 'Referentni broj rezervacije *',
      invoiceAmount: 'Iznos računa *',
      comment: 'Ostali komentari i zahtjevi',
      success: 'Vaš je zahtjev uspješno poslan.',
    },
    transferPoints: {
      mainTitle: 'Prenesi bodove',
      title: 'Koliko bodova želite prenijeti?',
      formTitle: 'Račun na koji želite prenijeti bodove',
      receiverFirstName: 'Ime *',
      receiverLastName: 'Prezime *',
      receiverEmail: 'Adresa e-pošte *',
      receiverLoyaltyId: 'Broj kartice za program vjernosti',
      allPointsSelection: 'Sve bodove',
      otherAmountSelection: 'Drugi iznos',
      pointsAvailable: 'Dostupni bodovi: ',
      points2Transfer: 'Bodovi za prijenos: ',
      success: 'Vaš je zahtjev uspješno poslan.',
    },
    activation: {
      success: [
        ' Ako smo pronašli e-poštu u bazi podataka, poslali smo vam poveznicu.',
        ' Čini se da već imate račun. Prijavite se.',
      ],
    },
    reservations: {
      title: 'Rezervacije',
      property: 'Objekt',
      check: 'Prijava/odjava',
      rate: 'Cijena',
      status: 'Status',
      checkRates: 'Provjerite cijene',
      noReservations: 'Nemate nadolazećih rezervacija.',
      newHolidays: 'Vrijeme je za vaš novi odmor.',
      noPropertyTitle: 'Nema pronađenih naziva objekata. PhobsID: ',
      bookingRef: 'Ref. br. rezervacije:',
      memberRate: 'Ukupna cijena za članove',
      discoverExperiences: 'Otkrijte nova iskustva',
      activeReservations: 'Aktivne rezervacije',
      pastReservations: 'Prijašnje rezervacije',
    },
  },
  de: {
    all: 'Alle',
    filters: 'Filter',
    clearFilters: 'Filter löschen',
    applyFilters: 'Filter anwenden',
    showFilters: 'Filter anzeigen',
    closeFilters: 'Filter schließen',
    destinations: 'Reiseziele',
    interests: 'Interessen',
    destination: 'Reiseziel',
    brands: 'Marken',
    types: 'Typen',
    starRating: 'Sterne-Bewertung',
    back: 'Dashboard',
    services: 'Einrichtungen/Dienstleistungen',
    sortBy: 'Sortiere nach',
    recommendedFirst: 'Sortieren nach Empfehlung',
    lowFirst: 'Preis - niedrigster zuerst',
    highFirst: 'Preis - höchster zuerst',
    lowPointsFirst: 'Punkte - niedrigste zuerst',
    highPointsFirst: 'Punkte - höchste zuerst',
    noResults: 'Keine Ergebnisse, Filter ändern',
    unavailableSeparator: 'Für die gewählten Daten nicht verfügbar',
    bookNow: 'Jetzt buchen',
    from: 'von',
    perUnit: 'pro Einheit',
    error: 'Fehler',
    holidayTypeFilter: 'Art des Urlaubs',
    property: 'Objekt',
    discoverMore: 'Mehr entdecken',
    confirm: 'Bestätigen',
    canceled: 'Storniert',
    notCanceled: 'Aktiv',
    formSubmitSuccess: 'Sie haben das Formular erfolgreich versendet.',
    loadMore: 'Mehr laden',
    results: 'Ergebnisse: ',
    allDestinations: 'Alle Reiseziele',
    allBrands: 'Alle marken',
    allInterests: 'Alle Interessen',
    error403: {
      title: '403',
      text: 'Sie müssen angemeldet sein, um auf diese Seite zugreifen zu können.',
      goHome: 'Startseite',
    },
    searchApp: {
      placeholder: 'Suchen nach Immobilien, Angeboten, Ideen ...',
      suggestionsTitle: 'Finden Sie Ihren perfekten Kurzurlaub',
      showFilters: 'Filter anzeigen',
      clearFilters: 'Alles löschen',
      applyFilters: 'Filter anwenden',
      cancelFilters: 'Stornieren',
      resultType: {
        offer: 'Sonderangebot',
      },
      filters: {
        propertyType: 'Art der Immobilie',
        destination: 'Reiseziel',
        brand: 'Marke',
      },
      noResults: 'Es gibt keine Ergebnisse für diese Abfrage.',
      showing: 'Gezeigt',
      outOf: 'von',
      results: 'ergebnisse',
    },
    focusedSearch: {
      placeholder: 'Ihren Aufenthalt finden',
      showAll: 'Alle anzeigen',
      properties: 'Unterkunft',
      specialOffers: 'Sonderangebote',
      searchFor: 'Suchen nach:',
    },
    bookingWidget: {
      planYourStay: 'Planen Sie Ihren Aufenthalt',
      whereAreYouGoing: 'Wohin möchten Sie?',
      noResultsTitle: 'Keine Ergebnisse für dieses Stichwort gefunden.',
      noResultsMessage: 'Wählen Sie eine der folgenden Optionen aus oder geben Sie ein anderes Stichwort ein.',
    },
    propertyTypes: {
      hotels: 'Hotels',
      resorts: 'Resorts',
      camping: 'Camping',
    },
    campingTypes: {
      pitches: 'Stellplätze',
      'mobile-homes': 'Mobilheime',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Wohin wollen Sie gehen?',
      stepTitle2: 'Welches Hotel, Resort oder Campingplatz?',
      stepTitle3: 'Daten auswählen',
      stepTitle4: 'Gästeanzahl wählen',
      checkRatesButton: 'Preise prüfen',
      backLabel: 'Zurück',
      closeButtonLabel: 'Schließen',
      allDestinations: 'Alle Reiseziele auswählen',
      allProperties: 'Alle auswählen in',
      allPropertiesInDestination: 'Alle Unterkunft am aktuellen Ziel',
      hotelsResorts: 'Hotels und Resorts',
      campsites: 'Campingplätze',
      noProperties: 'Keine Objekte zu zeigen.',
      serachOverview: 'Suchübersicht',
      destination: 'Reiseziel:',
      edit: 'Bearbeiten',
      nights: 'nächte',
    },
    offers: {
      nrOfAvailable: 'Angebote zur Suche verfügbar',
      titleNoAvailable: 'Für Ihre Suche sind keine Sonderangebote verfügbar.',
      titleNoAvailableVariants: 'Das Sonderangebot ist abgelaufen, sehen Sie sich unsere aktiven Angebote an',
      subtitleNoAvailable: 'Wir empfehlen die folgenden anderen Optionen:',
      recommendedOffers: 'Empfohlene Sonderangebote',
      minimumStayPrefix: 'Mindestanzahl an Nächten:',
      period: 'Zeitraum:',
      filter: 'Angebote filtern',
      allHolidays: 'Alle Arten von Urlauben',
      allProperties: 'Alle Objekte',
      from: 'Ab',
      upTo: 'Bis zu',
      recommended: 'Für Sie empfohlen',
      popularNow: 'Aktuell beliebt',
      allOffers: 'Alle Angebote',
    },
    newsletter: {
      firstName: 'Vorname *',
      lastName: 'Nachname *',
      titleAll: 'Herr/Frau',
      titleMr: 'Herr',
      titleMrs: 'Frau',
      email: 'E-Mail *',
      gender: 'Anrede *',
      birthDate: 'Geburtsdatum',
      country: 'Land',
      brands: 'Unterkunftsarten *',
      language: 'Newslettersprache *',
      consent: 'Halten Sie mich auf dem Laufendem über Neuigkeiten, Angebote und exklusive Angebote.',
      info: 'Wir respektieren Ihre Privatsphäre und verpflichten uns, Ihre personenbezogenen Daten zu schützen. ' +
        'Weitere Informationen zum Schutz Ihrer personenbezogenen Daten finden Sie in unseren {privacyPlocy}',
      privacyPolicy: 'Datenschutzbestimmungen',
      register: 'Anmelden',
      submitSuccess: 'Formular erfolgreich versendet.',
    },
    contact: {
      title: 'Kontaktformular',
      subtitle: 'Sie können uns auch über das Kontaktformular eine Nachricht oder Frage zukommen lassen. Wir werden Ihnen so schnell wie möglich antworten.',
      name: 'Vor- und Nachname*',
      email: 'E-Mail-Addresse*',
      subject: 'Betreff*',
      property: 'Objekt',
      message: 'Ihre Nachricht',
      send: 'Schicken',
      requiredFields: '* Pflichtfelder',
      submitSuccess: 'Formular erfolgreich versendet.',
    },
    interestsTab: {
      title: 'Meine Interessen',
      brand: 'Marke',
      destination: 'Reiseziel',
      holiday: 'Art des urlaubs und interessen',
      campsite: 'Campingplatz',
      leadText: 'Bitte geben Sie Ihre Reiseinteressen ein.',
      dataProtection: '<p>Wir respektieren Ihre Privatsphäre und verpflichten uns, Ihre personenbezogenen Daten zu schützen. Wir erheben verschiedene Arten von personenbezogenen Daten über Sie, abhängig von Ihrer Beziehung zu uns und den von Ihnen genutzten Leistungen. Wir erheben und verarbeiten Ihre personenbezogenen Daten für legitime Zwecke und auf einer gültigen Rechtsgrundlage.</p><p>Weitere Informationen zum Schutz Ihrer personenbezogenen Daten finden Sie in unserer <a href="/de/privatsphaere/"> Datenschutzerklärung</a>.</p>',
      updateSuccess: 'Sie haben Ihre Interessen erfolgreich aktualisiert.',
    },
    preferencesTab: {
      title: 'Präferenzen',
      leadText: 'Bitte beachten Sie, dass nicht alle Optionen in allen Unterkünften und zu jeder Zeit allgemein verfügbar sind.',
      bedding: 'Kissen- und Bettpräferenzen',
      notAvailableInCampsites: '*Auf Campingplätzen nicht verfügbar.',
      rooms: 'Zimmerpräferenzen',
      roomsExtra: 'Je nach Verfügbarkeit und dem von Ihnen gebuchten Hotel und Zimmertyp.',
      services: 'Zusatzleistungen',
      servicesExtra: 'Kostenlos, nur in bestimmten Unterkünften verfügbar.',
      food: 'Essenspräferenzen',
      childEquipment: 'Zusätzliche Baby- und Kinderausstattung (kostenlos)',
      pickupAtReception: '*Abholung an der Hotelrezeption.',
      typeHere: 'hier eintragen',
      updateSuccess: 'Sie haben Ihre Präferenzen erfolgreich aktualisiert.',
    },
    extraServices: {
      title: 'Zusätzliche leistungen (gegen gebühr) ',
      text: 'Haben Sie noch weitere Wünsche an das Hotel?',
      footer: 'z.B. Luftballons, Kuchen, Blumen oder Getränke im Zimmer',
    },
    activity: {
      activity: 'Aktivität',
      youHave: 'Sie haben: ',
      expiration: 'ABLAUFDATUM... haben wir das?',
      transferPoints: 'punkte übertragen',
      missingPoints: 'fehlende Punkte erhalten',
      pointsActivity: 'Aktivierte Punkte',
      date: 'Datum',
      source: 'Quelle',
      points: 'Punkte',
      noActivity: 'Derzeit sind keine Punkte aktiviert.',
      title: 'Aktivierte Punkte',
      transactionTypes: ['Bleiben', 'Umfrage', 'Registration', 'Kontakt bearbeitet', 'Punkteübertragung', 'Sonstiges', 'Punktesammlung', 'Punkteeinlösung', 'Abgelaufen', 'Zusatzleistungen'],
    },
    activityPointsCommon: {
      requiredFields: '* Diese Felder sind Pflichtfelder',
      send: 'Schicken',
    },
    awards: {
      all: 'Alle',
      recommended: 'Empfohlene Prämien',
      title: 'MaiStar Preise',
      recommendedTitle: 'Empfohlene Preise für Ihren nächsten Aufenthalt',
      points: 'Punkte',
      discoverMore: 'Mehr entdecken',
      available: 'Verfügbar',
      unavailable: 'Nicht verfügbar',
      noReservations: 'Sie haben keine anstehenden Buchungen. Es ist Zeit für Ihren neuen Urlaub.',
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Willkommen',
      displayName: 'Vor- und Nachnamen anzeigen',
      level: 'Stufe',
      editprofile: 'Profil bearbeiten',
      membershipNumber: 'Mitgliedsnummer',
      memberSince: 'Mitglied seit',
      viewPoints: 'Aktivierte Punkte anzeigen',
      viewBookings: 'alle Buchungen anzeigen',
      viewProperties: 'view all properties',
      enlargeQr: 'QR-Code vergrößern',
      youHave: 'Sie haben',
      points: 'punkte',
      myBookings: 'Meine Buchungen',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Preise',
      maistarRewards: 'MaiStar Rewards',
      viewRewards: 'alle Preise anzeigen',
      noRewards: 'keine Preise',
      moreAboutStatus: 'Mehr über Ihren Status',
      scrollDown: 'Nach unten scrollen',
      expiresOn: 'Läuft ab am:',
      personalDetails: 'Persönliche Daten',
      addToAppleWallet: 'Hinzufügen zu Apple Wallet ',
      addToGoogleWallet: 'Hinzufügen zu Google Wallet ',
    },
    obtainPoints: {
      mainTitle: 'Fehlende Punkte erhalten',
      title: 'Fehlende Punkte für eine Buchung?<br>Senden Sie eine Anfrage für fehlende Punkte.',
      formTitle: 'Bitte, füllen Sie dieses Formular mit Ihren Daten aus',
      property: 'Objekt *',
      arrivalDate: 'Ankunftsdatum *',
      departureDate: 'Abreisedatum *',
      pointsAwardedTime: 'Die Punkte werden 72 Stunden nach dem Checkout hinzugefügt.',
      bookingReferenceNumber: 'Buchungsreferenznummer *',
      invoiceAmount: 'Rechnungsbetrag *',
      comment: 'Andere Kommentare und Anfragen',
      success: 'Ihre Anfrage wurde erfolgreich versendet.',
    },
    transferPoints: {
      mainTitle: 'Punkte übertragen',
      title: 'Wie viele Punkte möchten Sie übertragen?',
      formTitle: 'Konto, auf das Sie Punkte übertragen möchten',
      receiverFirstName: 'Vorname *',
      receiverLastName: 'Nachname *',
      receiverEmail: 'E-Mail-Addresse *',
      receiverLoyaltyId: 'Treuekartennummer *',
      allPointsSelection: 'Alle Punkte',
      otherAmountSelection: 'Anderer Betrag',
      pointsAvailable: 'Verfügbare Punkte: ',
      points2Transfer: 'Zu übertragende Punkte',
      success: 'Ihre Anfrage wurde erfolgreich versendet.',
    },
    activation: {
      success: [
        'If Wenn wir eine E-Mail in der Datenbank gefunden haben, haben wir Ihnen einen Link gesendet.',
        'It Anscheinend haben Sie bereits ein Konto. Bitte melden Sie sich an.',
      ],
    },
    reservations: {
      title: 'Buchung',
      property: 'Objekt',
      check: 'Check in / Check out',
      rate: 'Preis',
      status: 'Status',
      checkRates: 'Preise prüfen',
      noReservations: 'Sie haben keine anstehenden Buchungen.',
      newHolidays: 'Es ist Zeit für Ihren neuen Urlaub.',
      noPropertyTitle: 'Kein Objektname gefunden. PhobsID: ',
      bookingRef: 'Buchungsreferenz:',
      memberRate: 'Gesamtkosten für Mitglieder',
      discoverExperiences: 'Entdecken Sie neue Erfahrungen',
      activeReservations: 'Aktive Buchungen',
      pastReservations: 'Frühere Buchungen',
    },
  },
  it: {
    all: 'Tutto',
    filters: 'Filtri',
    clearFilters: 'Cancella filtri',
    applyFilters: 'Applica il filtro',
    showFilters: 'Mostra filtri',
    closeFilters: 'Chiudi i filtri.',
    destinations: 'Destinazioni',
    interests: 'Interessi',
    destination: 'Destinazione',
    brands: 'Brand',
    types: 'Tipi',
    starRating: 'Numero di stelle',
    back: 'Pannello di controllo',
    services: 'Impianti e servizi',
    sortBy: 'Ordina per',
    recommendedFirst: 'Ordina per Consigliati',
    lowFirst: 'Prezzo - dal più basso',
    highFirst: 'Prezzo - dal più alto',
    lowPointsFirst: 'Punti - dal più basso',
    highPointsFirst: 'Punti - dal più alto',
    noResults: 'Nessun risultato, modifica il filtro',
    unavailableSeparator: 'Non disponibile per le date selezionate',
    bookNow: 'Prenota ora',
    from: 'da',
    perUnit: 'per unità',
    error: 'Errore',
    holidayTypeFilter: 'Tipo di vacanze',
    property: 'Struttura',
    discoverMore: 'Maggiori informazioni',
    confirm: 'Conferma',
    canceled: 'Annullato',
    notCanceled: 'Attivo',
    formSubmitSuccess: 'Modulo inviato correttamente.',
    loadMore: 'Carica altro',
    results: 'Risultati:',
    allDestinations: 'Tutte le destinazioni',
    allBrands: 'Tutte le marche',
    allInterests: 'Tutti gli interessi',
    error403: {
      title: '403',
      text: 'Devi essere loggato per accedere a questa pagina.',
      goHome: 'Home',
    },
    searchApp: {
      placeholder: 'Ricerca strutture, offerte, idee ...',
      suggestionsTitle: 'Trova la tua vacanza perfetta',
      showFilters: 'Mostra filtri',
      clearFilters: 'Cancella tutto',
      applyFilters: 'Applica filtro',
      cancelFilters: 'Cancella',
      resultType: {
        offer: 'Offerta speciale',
      },
      filters: {
        propertyType: 'Tipo di struttura',
        destination: 'Destinazione',
        brand: 'Brand',
      },
      noResults: 'Nessun risultato per questa ricerca.',
      showing: 'Presentazione',
      outOf: 'di',
      results: 'risultati',
    },
    focusedSearch: {
      placeholder: 'Trova il tuo soggiorno',
      showAll: 'Mostra tutto',
      properties: 'Proprieta',
      specialOffers: 'Offerte speciali',
      searchFor: 'Cerca:',
    },
    bookingWidget: {
      planYourStay: 'Pianificate il vostro soggiorno',
      whereAreYouGoing: 'Dove desidera andare?',
      noResultsTitle: 'Nessun risultato con questa parola chiave.',
      noResultsMessage: 'Selezionate una delle seguenti parole chiave o inseritene una diversa.',
    },
    propertyTypes: {
      hotels: 'Hotels',
      resorts: 'Resorts',
      camping: 'Camping',
    },
    campingTypes: {
      pitches: 'Piazzole',
      'mobile-homes': 'Case mobili',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Dove vorresti andare?',
      stepTitle2: 'Quale hotel, resort o campeggio?',
      stepTitle3: 'Seleziona le date',
      stepTitle4: 'Seleziona il numero degli ospiti',
      checkRatesButton: 'Controlla le tariffe',
      backLabel: 'Indietro',
      closeButtonLabel: 'Prossimo',
      allDestinations: 'Seleziona tutte le destinazioni',
      allProperties: 'Seleziona tutte le strutture da',
      allPropertiesInDestination: 'Tutte le strutture nella destinazione attuale',
      hotelsResorts: 'Hotel e resort',
      campsites: 'Campeggi',
      noProperties: 'Nessuna proprietà da mostrare.',
      serachOverview: 'Panoramica della ricerca',
      destination: 'Destinazione:',
      edit: 'Modificare',
      nights: 'notti',
    },
    offers: {
      nrOfAvailable: 'offerte disponibili per la tua ricerca',
      titleNoAvailable: 'Non sono disponibili offerte speciali per la tua ricerca.',
      titleNoAvailableVariants: 'L’offerta speciale è terminata. Verificate le nostre offerte attive qui sotto',
      subtitleNoAvailable: 'Consigliamo le seguenti alternative:',
      recommendedOffers: 'Offerte speciali consigliate',
      minimumStayPrefix: 'Minimo numero di notti:',
      period: 'Periodo:',
      filter: 'Filtra offerte',
      allHolidays: 'Tutte le vacanze',
      allProperties: 'Tutte le strutture',
      from: 'Da',
      upTo: 'Fino al',
      recommended: 'Consigliato per te',
      popularNow: 'Popolare in questo momento',
      allOffers: 'Tutte le offerte',
    },
    newsletter: {
      firstName: 'Nome *',
      lastName: 'Cognome *',
      titleAll: 'Sig.',
      titleMr: 'Sig.',
      titleMrs: 'Sig.ra.',
      email: 'E-mail *',
      gender: 'Saluto *',
      birthDate: 'Data di nascita',
      country: 'Stato',
      brands: 'Tipo di alloggio *',
      language: 'Lingua della newsletter *',
      consent: 'Tenetemi aggiornato/a sulle novità, offerte e affari speciali per affiliati.',
      info: 'Rispettiamo la Sua privacy e ci impegniamo a proteggere i Suoi dati personali. ‘+ Per maggiori informazioni sulla protezione dei Suoi dati personali, La preghiamo di consultare la nostra {privacyPolicy}',
      privacyPolicy: 'Politica sulla privacy',
      register: 'Registrati',
      submitSuccess: 'Modulo inviato con successo.',
    },
    contact: {
      title: 'Modulo di Contatto',
      subtitle: 'Puoi anche inviarci il tuo messaggio o domanda tramite il modulo di contatto. Ti risponderemo il prima possibile.',
      name: 'Nome e cognome*',
      email: 'Indirizzo E-mail*',
      subject: 'Oggetto*',
      property: 'Struttura',
      message: 'Il tuo messaggio',
      send: 'Invia',
      requiredFields: '* Campi richiesti',
      submitSuccess: 'Modulo inviato con successo.',
    },
    interestsTab: {
      title: 'I miei interessi',
      brand: 'Brand',
      destination: 'Destinazione',
      holiday: 'Tipo di vacanza e interessi',
      campsite: 'Campeggio',
      leadText: 'Vi preghiamo di inserire i vostri interessi di viaggio.',
      dataProtection: '<p>Rispettiamo la Sua privacy e ci impegniamo a proteggere i Suoi dati personali. Raccogliamo diversi tipi di dati personali che La riguardano, in relazione al Suo rapporto con noi e ai servizi che utilizza. In ogni caso, raccogliamo ed elaboriamo i Suoi dati personali per scopi legittimi e su valide basi legali.</p><p>Per maggiori informazioni sulla protezione dei Suoi dati personali, La preghiamo di consultare la nostra <a href="/it/informativa-privacy/">Informativa sulla privacy</a>.</p>',
      updateSuccess: 'Hai aggiornato con successo i tuoi interessi.',
    },
    preferencesTab: {
      title: 'Preferenze ',
      leadText: 'Vi preghiamo di prendere nota che non tutte le opzioni sono universalmente disponibili in tutte le strutture e in ogni momento.',
      bedding: 'Preferenze di cuscini e biancheria da letto',
      notAvailableInCampsites: '*Non disponibile nei campeggi.',
      rooms: 'Preferenze di camere',
      roomsExtra: 'In base alla disponibilità e in base alla tipologia di hotel e di camera prenotata.',
      services: 'Servizi aggiuntivi',
      servicesExtra: 'Senza supplemento, disponibile soltanto in determinate strutture.',
      food: 'Preferenze di cibo',
      childEquipment: 'Attrezzatura aggiuntiva per neonati e bambini (Senza supplemento)',
      pickupAtReception: '*Da prelevare alla reception dell’hotel.',
      typeHere: 'digitare qui',
      updateSuccess: 'Hai aggiornato con successo i tuoi preferenze.',
    },
    extraServices: {
      title: 'Servizi aggiuntivi (con supplemento) ',
      text: 'Ha qualche altra richiesta da fare all’hotel?',
      footer: 'per esempio: palloncini, torta, fiori o bevande in camera',
    },
    activity: {
      activity: 'Attività',
      youHave: 'hai:',
      expiration: 'DATA di scadenza.. noi abbiamo questo?',
      transferPoints: 'punti da trasferire',
      missingPoints: 'ottieni i punti mancanti',
      pointsActivity: 'Attività dei punti',
      date: 'Data',
      source: 'Sorgente',
      points: 'Punti',
      noActivity: 'Al momento, non ci sono attività punti.',
      title: 'Attività a punti',
      transactionTypes: ['Soggiorno', 'Sondaggio', 'Registrazione', 'Contatto modificato', 'Trasferimento punti', 'Altro', 'Richiesta punti', 'Riscatto punti', 'Scaduto', 'Servizi esclusi dal trattamento a pensione'],
    },
    activityPointsCommon: {
      requiredFields: '* Questi campi sono obbligatori',
      send: 'Invia',
    },
    awards: {
      all: 'Tutto',
      recommended: 'Premi suggeriti',
      title: 'Premi MaiStar',
      recommendedTitle: 'Premi consigliati per il tuo prossimo soggiorno',
      points: 'punti',
      discoverMore: 'Maggiori informazioni',
      available: 'Disponibile',
      unavailable: 'Non disponibile',
      noReservations: 'Non hai prenotazioni imminenti. È il momento di una nuova vacanza..',
    },
    dashboard: {
      title: 'Pannello di controllo',
      welcome: 'Benvenuto/a,',
      displayName: 'Nome da visualizzare',
      level: 'Livello',
      editprofile: 'Modifica Profilo',
      membershipNumber: 'Numero di iscrizione',
      memberSince: 'Affiliato da',
      viewPoints: "Visualizza l'attività dei punti",
      viewBookings: 'visualizza tutte le prenotazioni',
      viewProperties: 'view all properties',
      enlargeQr: 'Ingrandisci il codice QR',
      youHave: 'Hai',
      points: 'punti',
      myBookings: 'Le mie prenotazioni',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Premi',
      maistarRewards: 'MaiStar Rewards',
      viewRewards: 'visualizza tutti i premi',
      noRewards: 'nessun premio',
      moreAboutStatus: 'Maggiori informazioni sul tuo stato',
      scrollDown: 'Scorrere verso il basso',
      expiresOn: 'Scade il:',
      personalDetails: 'Dati personali',
      addToAppleWallet: 'Aggiungi a Apple Wallet',
      addToGoogleWallet: 'Aggiungi a Google Wallet',
    },
    obtainPoints: {
      mainTitle: 'Ottieni punti mancanti',
      title: 'Punti mancanti per una prenotazione?<br>Invia una richiesta per i punti mancanti.',
      formTitle: 'Ti preghiamo di compilare questo modulo con i tuoi dati',
      property: 'Struttura *',
      arrivalDate: 'Data di arrivo *',
      departureDate: 'Data di partenza *',
      pointsAwardedTime: 'I punti verranno accreditati 72 ore dopo il check-out.',
      bookingReferenceNumber: 'Numero di riferimento per la prenotazione *',
      invoiceAmount: 'Importo fattura *',
      comment: 'Altri commenti e richieste',
      success: 'La tua richiesta è stata inoltrata con successo.',
    },
    transferPoints: {
      mainTitle: 'Punti da trasferire',
      title: 'Quanti punti desidera trasferire?',
      formTitle: 'Conto su cui desideri trasferire i punti',
      receiverFirstName: 'Nome *',
      receiverLastName: 'Cognome *',
      receiverEmail: 'Indirizzo E-mail *',
      receiverLoyaltyId: 'Numero carta fedeltà *',
      allPointsSelection: 'Tutti i punti',
      otherAmountSelection: 'Altro importo',
      pointsAvailable: 'Punti disponibili:',
      points2Transfer: 'Punti da trasferire:',
      success: 'La tua richiesta è stata inoltrata con successo.',
    },
    activation: {
      success: ['Se abbiamo trovato l\'E-mail nel database, ti abbiamo inviato il link.', 'Sembra che tu abbia già un account. Accedete, per favore.'],
    },
    reservations: {
      title: 'Prenotazioni',
      property: 'Struttura',
      check: 'Arrivo Partenza',
      rate: 'Valuta',
      status: 'Stato',
      checkRates: 'Controlla le tariffe',
      noReservations: 'Non hai prenotazioni imminenti.',
      newHolidays: 'È tempo di nuove vacanze.',
      noPropertyTitle: 'Nessun nome di proprietà trovato. FobsID:',
      bookingRef: 'Riferimento prenotazione:',
      memberRate: 'Tariffa totale per i membri',
      discoverExperiences: 'Scopri nuove esperienze',
      activeReservations: 'Prenotazioni attive',
      pastReservations: 'Prenotazioni passate',
    },
  },
  nl: {
    all: 'Allemaal',
    filters: 'Filters',
    clearFilters: 'Wis filters',
    applyFilters: 'Filters toepassen',
    showFilters: 'Filters tonen',
    closeFilters: 'Sluit filters',
    destinations: 'bestemmingen',
    interests: 'Interesses',
    destination: 'Bestemming',
    brands: 'Merken',
    types: 'Types',
    starRating: 'Sterrenclassificatie',
    back: 'Dashboard',
    services: 'Faciliteiten/Diensten',
    sortBy: 'Sorteer op',
    recommendedFirst: 'Sorteer op aanbevolen',
    lowFirst: 'Prijs: laagste eerst',
    highFirst: 'Prijs: hoogste eerst',
    lowPointsFirst: 'Punten - laagste eerst',
    highPointsFirst: 'Punten - hoogste eerst',
    noResults: 'Geen resultaten, filter aanpassen',
    unavailableSeparator: 'Niet beschikbaar voor de geselecteerde data',
    bookNow: 'Boek nu',
    from: 'van',
    perUnit: 'per accommodatie',
    error: 'Fout',
    holidayTypeFilter: 'Soort vakantie',
    property: 'Eigendom',
    discoverMore: 'Ontdek meer',
    confirm: 'Bevestigen',
    canceled: 'Geannuleerd',
    notCanceled: 'Actief',
    formSubmitSuccess: 'Het formulier is verzonden.',
    loadMore: 'Meer laden',
    results: 'Resultaten:',
    allDestinations: 'Alle bestemmingen',
    allBrands: 'Alle merken',
    allInterests: 'Alle interesses',
    error403: {
      title: '403',
      text: 'U moet ingelogd zijn om toegang te krijgen tot deze pagina.',
      goHome: 'Home',
    },
    searchApp: {
      placeholder: 'Zoek eigenschappen, aanbiedingen, ideeën...',
      suggestionsTitle: 'Vind de volmaakte plek om te ontspannen',
      showFilters: 'Toon filters',
      clearFilters: 'Wis alles',
      applyFilters: 'Filter toepassen',
      cancelFilters: 'Annuleer',
      resultType: {
        offer: 'Speciale aanbieding',
      },
      filters: {
        propertyType: 'Type onderkomen',
        destination: 'Bestemming',
        brand: 'Merk',
      },
      noResults: 'Er zijn geen resultaten voor deze zoekopdracht.',
      showing: 'Tonen',
      outOf: 'van de',
      results: 'resultaten',
    },
    focusedSearch: {
      placeholder: 'Vind je verblijf',
      showAll: 'Alles tonen',
      properties: 'Eigendom',
      specialOffers: 'Speciale aanbiedingen',
      searchFor: 'Zoeken naar:',
    },
    bookingWidget: {
      planYourStay: 'Plan uw verblijf',
      whereAreYouGoing: 'Waar gaat u naartoe?',
      noResultsTitle: 'Er zijn geen resultaten voor dit trefwoord.',
      noResultsMessage: 'Selecteer een van de volgende opties of voer een ander trefwoord in.',
    },
    propertyTypes: {
      hotels: 'Hotels',
      resorts: 'Resorts',
      camping: 'Camping',
    },
    campingTypes: {
      pitches: 'Kampeerplaatsen',
      'mobile-homes': 'Stacaravans',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Waar wil je heen?',
      stepTitle2: 'Welk hotel, resort of camping?',
      stepTitle3: 'Selecteer data',
      stepTitle4: 'Selecteer aantal gasten',
      checkRatesButton: 'Controleer prijzen',
      backLabel: 'Rug',
      closeButtonLabel: 'Dichtbij',
      allDestinations: 'Selecteer alle bestemmingen',
      allProperties: 'Selecteer alle eigenschappen van',
      allPropertiesInDestination: 'Alle Eigendommen in huidige bestemming',
      hotelsResorts: 'Hotels en resorts',
      campsites: 'Campings',
      noProperties: 'Geen eigenschappen om te tonen.',
      serachOverview: 'Zoekoverzicht',
      destination: 'Bestemming:',
      edit: 'Bewerk',
      nights: 'nachten',
    },
    offers: {
      nrOfAvailable: 'aanbiedingen beschikbaar voor uw zoekopdracht',
      titleNoAvailable: 'Er zijn geen speciale aanbiedingen beschikbaar voor je zoekopdracht.',
      titleNoAvailableVariants: 'Deze speciale aanbieding is verlopen. Check onderaan voor nieuwe aanbiedingen',
      subtitleNoAvailable: 'We raden de volgende alternatieven aan:',
      recommendedOffers: 'Aanbevolen speciale aanbiedingen',
      minimumStayPrefix: 'Minimaal aantal nachten:',
      period: 'Periode:',
      filters: 'Aanbiedingen sorteren',
      allHolidays: 'Alle vakanties',
      allProperties: 'Alle eigenschappen',
      from: 'Van',
      upTo: 'Tot',
      recommended: 'Aanbevolen voor jou',
      popularNow: 'Populair op dit moment',
      allOffers: 'Alle aanbiedingen',
    },
    newsletter: {
      firstName: 'Voornaam *',
      lastName: 'Achternaam *',
      titleAll: 'Mevr./Dhr.',
      titleMr: 'Dhr.',
      titleMrs: 'Mevr.',
      email: 'E-mail *',
      gender: 'Aanhef *',
      birthDate: 'Geboortedatum',
      country: 'Land',
      brands: 'Accommodatiesoort *',
      language: 'Taal nieuwsbrief *',
      consent: 'Houdt me op de hoogte van nieuws, aanbiedingen en exclusieve ledenaanbiedingen.',
      info: 'Wij respecteren uw privacy, en beschermen uw persoonsgegevens' +
      'Voor meer informatie over de bescherming van uw persoonsgegevens kunt u terecht bij ons {privacyPolicy}',
      privacyPolicy: 'Privacybeleid',
      register: 'Aanmelden',
      submitSuccess: 'Formulier is verzonden.',
    },
    contact: {
      title: 'Contactformulier',
      subtitle: 'U kunt ons ook uw bericht of vraag sturen via het contactformulier. We zullen zo snel mogelijk antwoorden.',
      name: 'Naam en achternaam*',
      email: 'E-mailadres*',
      subject: 'Onderwerp*',
      property: 'Eigendom',
      message: 'Jouw bericht',
      send: 'Versturen',
      requiredFields: '* Verplichte velden',
      submitSuccess: 'Formulier is verzonden.',
    },
    interestsTab: {
      title: 'Mijn interesses',
      brand: 'Merk',
      destination: 'Bestemming',
      holiday: 'Soort vakantie en interesses',
      campsite: 'Camping',
      leadText: 'Vul uw reisinteresses in.',
      dataProtection: '<p>Wij respecteren uw privacy en beschermen uw persoonsgegevens. Wij verzamelen verschillende soorten persoonlijke gegevens over u, afhankelijk van uw relatie tot ons en de diensten die u gebruikt. In ieder geval verzamelen en verwerken wij uw gegevens voor gerechtigde doeleinden en op een wettig geldende basis.</p><p>Voor meer informatie over de bescherming van uw persoonsgegevens verwijzen wij naar onze <a href="/nl/privacy-beleid/">Privacy Mededeling</a>.</p>',
      updateSuccess: 'Uw interesses zijn bijgewerkt.',
    },
    preferencesTab: {
      title: 'Voorkeuren ',
      leadText: 'Houd er rekening mee dat niet alle opties overal en altijd beschikbaar zijn.',
      bedding: 'Voorkeur van kussens en beddengoed',
      notAvailableInCampsites: '*Niet beschikbaar op campings.',
      rooms: 'Kamervoorkeuren',
      roomsExtra: 'Indien beschikbaar, op basis van het hotel en kamertype dat u heeft geboekt.',
      services: 'Extra services',
      servicesExtra: 'Gratis, alleen beschikbaar in specifieke accommodaties.',
      food: 'Voedselvoorkeuren',
      childEquipment: 'Extra baby- en kinderuitrusting (gratis)',
      pickupAtReception: '*Op te halen bij de receptie van het hotel.',
      typeHere: 'typ hier',
      updateSuccess: 'Uw voorkeuren zijn bijgewerkt.',
    },
    extraServices: {
      title: 'Extra services (tegen betaling) ',
      text: 'Heeft u nog verdere wensen voor uw verblijf?',
      footer: 'Bijvoorbeeld ballonnen, taart, bloemen of drankjes op de kamer',
    },
    activity: {
      activity: 'Activiteit',
      youHave: 'jij hebt:',
      expiration: 'Vervaldatum.. hebben we dit?',
      transferPoints: 'punten overdragen',
      missingPoints: 'ontbrekende punten halen',
      pointsActivity: 'Punten Activiteit',
      date: 'Datum',
      source: 'Bron',
      points: 'Punten',
      noActivity: 'Momenteel is er geen puntenactiviteit.',
      title: 'Punten activiteit',
      transactionTypes: ['Verblijf', 'Enquête', 'Registratie', 'Contact bewerkt', 'Puntenoverdracht', 'Overig', 'Puntenclaim', 'Punten inwisselen', 'Verlopen', 'Extra verbruik'],
    },
    activityPointsCommon: {
      requiredFields: '* Deze velden zijn verplicht',
      send: 'Versturen',
    },
    awards: {
      all: 'Allemaal',
      recommended: 'Aanbevolen beloningen',
      title: 'MaiStar-beloningen',
      recommendedTitle: 'Aanbevolen prijzen voor uw volgende verblijf',
      points: 'punten',
      discoverMore: 'Ontdek meer',
      available: 'Beschikbaar',
      unavailable: 'Niet beschikbaar',
      noReservations: 'U heeft geen aankomende reserveringen. Het is tijd voor een nieuwe vakantie.',
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welkom',
      displayName: 'Weergavenaam',
      level: 'Peil',
      editprofile: 'Bewerk profiel',
      membershipNumber: 'Lidmaatschapsnummer',
      memberSince: 'Lid sinds',
      viewPoints: 'Puntenactiviteit bekijken',
      viewBookings: 'bekijk alle boekingen',
      viewProperties: 'view all properties',
      enlargeQr: 'Vergroot QR-code',
      youHave: 'Jij hebt',
      points: 'punten',
      myBookings: 'Mijn boekingen',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Beloningen',
      maistarRewards: 'MaiStar-beloningen',
      viewRewards: 'bekijk alle beloningen',
      noRewards: 'geen beloningen',
      moreAboutStatus: 'Meer over je status',
      scrollDown: 'Naar beneden scrollen',
      expiresOn: 'Verloopt op:',
      personalDetails: 'Persoonlijke gegevens',
      addToAppleWallet: 'Voeg toe aan Apple Wallet',
      addToGoogleWallet: 'Voeg toe aan Google Wallet',
    },
    obtainPoints: {
      mainTitle: 'Verkrijg ontbrekende punten',
      title: 'Ontbrekende punten voor een boeking?<br>Dien een verzoek voor ontbrekende punten in.',
      formTitle: 'Vul dit formulier in',
      property: 'Eigendom *',
      arrivalDate: 'Aankomstdatum *',
      departureDate: 'Vertrekdatum *',
      pointsAwardedTime: 'Punten worden 72 uur na het uitchecken toegevoegd.',
      bookingReferenceNumber: 'Boekingsreferentienummer *',
      invoiceAmount: 'Factuurbedrag *',
      comment: 'Overige opmerkingen en verzoeken',
      success: 'Uw aanvraag is ingediend.',
    },
    transferPoints: {
      mainTitle: 'Punten overzetten',
      title: 'Hoeveel punten wilt u overbrengen?',
      formTitle: 'Rekening waarnaar u punten wilt overboeken',
      receiverFirstName: 'Voornaam *',
      receiverLastName: 'Achternaam *',
      receiverEmail: 'E-mailadres *',
      receiverLoyaltyId: 'Klantenkaartnummer *',
      allPointsSelection: 'Alle punten',
      otherAmountSelection: 'Ander bedrag',
      pointsAvailable: 'Beschikbare punten:',
      points2Transfer: 'Over te dragen punten:',
      success: 'Uw aanvraag is ingediend.',
    },
    activation: {
      success: ['Als we de e-mail in de database hebben gevonden, hebben we je de link gestuurd.', 'Het lijkt erop dat je al een account hebt. Log alsjeblieft in.'],
    },
    reservations: {
      title: 'Boekingen',
      property: 'Eigendom',
      check: 'Controleer prijzen',
      rate: 'Tarief',
      status: 'Toestand',
      checkRates: 'Controleer koersen',
      noReservations: 'U heeft geen aankomende reserveringen.',
      newHolidays: 'Het is tijd voor je nieuwe vakantie.',
      noPropertyTitle: 'Vestigingsnaam niet gevonden. Fob-ID: ',
      bookingRef: 'Boekingsreferentie:',
      memberRate: 'Totaal ledentarief',
      discoverExperiences: 'Ontdek nieuwe ervaringen',
      activeReservations: 'Actieve reserveringen',
      pastReservations: 'Eerdere reserveringen',
    },
  },
  pl: {
    all: 'wszystkie',
    filters: 'Filtry',
    clearFilters: 'Wyczyść filtry',
    applyFilters: 'Zastosuj filtry',
    showFilters: 'Pokaż filtry',
    closeFilters: 'Zamknij filtry.',
    destinations: 'Destynacje',
    interests: 'Zainteresowania',
    destination: 'Cel podróży',
    brands: 'Marki',
    types: 'Rodzaje',
    starRating: 'Liczba gwiazdek',
    back: 'Panel',
    services: 'Obiekty/Usługi',
    sortBy: 'Sortuj według',
    recommendedFirst: 'Sortuj według polecanych',
    lowFirst: 'Cena - od najniższej',
    highFirst: 'Cena - od najwyższej',
    lowPointsFirst: 'Punkty - najpierw najniższe',
    highPointsFirst: 'Punkty - najpierw najwyższe',
    noResults: 'Brak wyników, zmodyfikuj filtr',
    unavailableSeparator: 'Niedostępne w wybranych terminach',
    bookNow: 'Zarezerwuj teraz',
    from: 'od',
    perUnit: 'Za jednostkę',
    error: 'Błąd',
    holidayTypeFilter: 'Rodzaj wakacji',
    property: 'Nieruchomość',
    discoverMore: 'Dowiedz się więcej',
    confirm: 'Potwierdź',
    canceled: 'Anulowane',
    notCanceled: 'Aktywny',
    formSubmitSuccess: 'Pomyślnie przesłałeś formularz.',
    loadMore: 'Załaduj więcej',
    results: 'Wyniki:',
    allDestinations: 'Wszystkie destynacje',
    allBrands: 'Wszystkie marki',
    allInterests: 'Wszystkie zainteresowania',
    error403: {
      title: '403',
      text: 'Musisz być zalogowany, aby uzyskać dostęp do tej strony.',
      goHome: 'Strona główna',
    },
    searchApp: {
      placeholder: 'Szukaj zakwaterowania, ofert, pomysłów…',
      suggestionsTitle: 'Znajdź swój idealny wyjazd',
      showFilters: 'Pokaż filtry',
      clearFilters: 'Wyczyść wszystko',
      applyFilters: 'Zastosuj filtry',
      cancelFilters: 'Anuluj',
      resultType: {
        offer: 'Oferta specjalna',
      },
      filters: {
        propertyType: 'Typ zakwaterowania',
        destination: 'Miejsce docelowe',
        brand: 'Marka',
      },
      noResults: 'Brak wyników dla tego zapytania.',
      showing: 'Pokazuj',
      outOf: 'od',
      results: 'wyniku',
    },
    focusedSearch: {
      placeholder: 'Znajdź swoje miejsce',
      showAll: 'Pokaż wszystko',
      properties: 'Nieruchomości',
      specialOffers: 'Oferty specjalne',
      searchFor: 'Szukaj:',
    },
    bookingWidget: {
      planYourStay: 'Zaplanuj swój pobyt',
      whereAreYouGoing: 'Dokąd się wybierasz?',
      noResultsTitle: 'Brak wyników dla tego słowa kluczowego.',
      noResultsMessage: 'Wybierz jedną z opcji lub wprowadź inne słowo kluczowe.',
    },
    propertyTypes: {
      hotels: 'Hotels',
      resorts: 'Resorts',
      camping: 'Camping',
    },
    campingTypes: {
      pitches: 'Parcele',
      'mobile-homes': 'Domki mobilne',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Dokąd chcesz pojechać?',
      stepTitle2: 'Który hotel, ośrodek lub kemping?',
      stepTitle3: 'Wybierz termin',
      stepTitle4: 'Wybierz liczbę gości',
      checkRatesButton: 'Sprawdź ceny',
      backLabel: 'Powrót',
      closeButtonLabel: 'Zamknij',
      allDestinations: 'Wybierz wszystkie destynacje',
      allProperties: 'Wybierz all in ',
      allPropertiesInDestination: 'Wszystkie nieruchomości w bieżącym miejscu docelowym',
      hotelsResorts: 'Hotele i ośrodki',
      campsites: 'Kempingi',
      noProperties: 'Brak obiektów do pokazania.',
      serachOverview: 'Przegląd wyszukiwania',
      destination: 'Cel podróży',
      edit: 'Edytuj',
      nights: 'noce',
    },
    offers: {
      nrOfAvailable: 'oferty dostępne w Twoim wyszukiwaniu',
      titleNoAvailable: 'Nie ma specjalnych ofert dostępnych dla Twojego wyszukiwania.',
      titleNoAvailableVariants: 'Oferta specjalna wygasła. Sprawdź nasze aktywne oferty poniżej',
      subtitleNoAvailable: 'Polecamy następujące alternatywy:',
      recommendedOffers: 'Polecane oferty specjalne',
      minimumStayPrefix: 'Minimalna liczba noclegów:',
      period: 'Okres:',
      filter: 'Filtruj oferty',
      allHolidays: 'Wszystkie typy wakacji',
      allProperties: 'Wszystkie obiekty',
      from: 'Od',
      upTo: 'Do',
      recommended: 'Polecane dla Ciebie',
      popularNow: 'Popularne teraz',
      allOffers: 'Wszystkie oferty',
    },
    newsletter: {
      firstName: 'Imię *',
      lastName: 'Nazwisko *',
      titleAll: 'Pan/Pani',
      titleMr: 'Pan',
      titleMrs: 'Pani',
      email: 'Email',
      gender: 'Tytuł',
      birthDate: 'Data urodzenia',
      country: 'Kraj',
      brands: 'Typ zakwaterowania *',
      language: 'Język newslettera *',
      consent: 'Informuj mnie na bieżąco o nowościach, ofertach i ekskluzywnych ofertach członkowskich.',
      info: 'Szanujemy Twoją prywatność i jesteśmy zobowiązani do ochrony Twoich danych osobowych. ' +
      'Aby uzyskać więcej informacji na temat ochrony Twoich danych osobowych, zapoznaj się z naszą {provacyPolicy}',
      privacyPolicy: 'Polityka prywatności',
      register: 'Zarejestruj się',
      submitSuccess: 'Pomyślnie przesłano formularz.',
    },
    contact: {
      title: 'Formularz kontaktowy',
      subtitle: 'Możesz również przesłać nam swoją wiadomość lub pytanie za pośrednictwem formularza kontaktowego. Odpowiemy najszybciej jak to możliwe.',
      name: 'Imię i nazwisko*',
      email: 'Adres e-mail*',
      subject: 'Temat*',
      property: 'Obiekt',
      message: 'Twoja wiadomość',
      send: 'Wyślij',
      requiredFields: '* Wymagane pola',
      submitSuccess: 'Pomyślnie przesłano formularz.',
    },
    interestsTab: {
      title: 'Moje Zainteresowania',
      brand: 'Marka',
      destination: 'Cel podróży',
      holiday: 'Rodzaj wakacji i zainteresowania',
      campsite: 'Kemping',
      leadText: 'Prosimy wpisać swoje preferencje wakacyjne.',
      dataProtection: '<p>Szanujemy Twoją prywatność i jesteśmy zobowiązani do ochrony Twoich danych osobowych. Zbieramy różne rodzaje Twoich danych osobowych, w zależności od Twoich relacji z nami oraz usług, z których korzystasz. Zawsze gromadzimy i przetwarzamy Twoje dane osobowe w uzasadnionych celach i na ważnej podstawie prawnej.</p><p>Aby uzyskać więcej informacji na temat ochrony Twoich danych osobowych, zapoznaj się z naszą <a href="/pl/polityka-prywatnosci/"> Informacja o ochronie prywatności</a>.</p>',
      updateSuccess: 'Pomyślnie zaktualizowałeś swoje zainteresowania.',
    },
    preferencesTab: {
      title: 'Preferencje',
      leadText: 'Należy pamiętać, że nie wszystkie opcje są ogólnie dostępne we wszystkich obiektach i przez cały czas.',
      bedding: 'Preferencje dotyczące poduszek i pościeli',
      notAvailableInCampsites: '* Nie są dostępne na kempingach.',
      rooms: 'Preferencje dotyczące pokoju',
      roomsExtra: 'W zależności od dostępności, w oparciu o rodzaj zarezerwowanego hotelu i pokoju.',
      services: 'Dodatkowe usługi',
      servicesExtra: 'Bezpłatnie, dostępne tylko w określonych obiektach.',
      food: 'Preferencje żywieniowe',
      childEquipment: 'Dodatkowe wyposażenie dla dzieci i niemowląt (bezpłatnie)',
      pickupAtReception: '* Do odbioru w recepcji hotelu.',
      typeHere: 'prosimy wpisać tutaj',
      updateSuccess: 'Pomyślnie zaktualizowałeś swoje preferencje.',
    },
    extraServices: {
      title: 'Dodatkowe usługi (dodatkowa opłata) ',
      text: 'Czy mają Państwo dodatkowe życzenia dotyczące hotelu?',
      footer: 'np. balony, tort, kwiaty lub drinki w pokoju',
    },
    activity: {
      activity: 'Aktywne punkty',
      youHave: 'które posiadasz: ',
      expiration: 'DATA WAŻNOŚCI.. czy mamy to?',
      transferPoints: 'punkty transferowe',
      missingPoints: 'zdobądź brakujące punkty',
      pointsActivity: 'Aktywne punkty',
      date: 'Data',
      source: 'Źródło',
      points: 'Punkty',
      noActivity: 'Obecnie nie masz aktywnych punktów.',
      title: 'Aktywne punkty',
      transactionTypes: ['Pobyt', 'Ankieta', 'Rejestracja', 'Kontakt edytowany', 'Przeniesienie punktów', 'Inne', 'Punkty odebrane', 'Punkty wykorzystane', 'Wygasłe', 'Dodatkowe usługi'],
    },
    activityPointsCommon: {
      requiredFields: '* Te pola są wymagane',
      send: 'Wyślij',
    },
    awards: {
      all: 'wszystkie',
      recommended: 'Rekomendowane nagrody',
      title: 'Nagrody MaiStar',
      recommendedTitle: 'Polecane nagrody na kolejny pobyt',
      points: 'punkty',
      discoverMore: 'Dowiedz się więcej',
      available: 'Dostępne',
      unavailable: 'Niedostępne',
      noReservations: 'Nie masz nadchodzących rezerwacji. To czas na Twoje nowe wakacje. ',
    },
    dashboard: {
      title: 'Panel',
      welcome: 'Witay,',
      displayName: 'Wyświetlana nazwa',
      level: 'Poziom',
      editprofile: 'Edytuj profil',
      membershipNumber: 'Numer członkowski',
      memberSince: 'Członek od',
      viewPoints: 'Zobacz aktywne punkty',
      viewBookings: 'zobacz wszystkie rezerwacje',
      viewProperties: 'view all properties',
      enlargeQr: 'Powiększ kod QR',
      youHave: 'Posiadasz',
      points: 'punkty',
      myBookings: 'Moje rezerwacje',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Nagrody',
      maistarRewards: 'Nagrody MaiStar',
      viewRewards: 'pokaż wszystkie nagrody',
      noRewards: 'brak nagród',
      moreAboutStatus: 'Więcej o twoim statusie',
      scrollDown: 'Przewiń w dół',
      expiresOn: 'Upływa w dniu:',
      personalDetails: 'Dane osobowe',
      addToAppleWallet: 'Dodaj do Portfela Apple',
      addToGoogleWallet: 'Dodaj do Portfela Google',
    },
    obtainPoints: {
      mainTitle: 'zdobądź brakujące punkty',
      title: 'Brakuje punktów za rezerwację?<br>Prześlij wniosek o brakujące punkty.',
      formTitle: 'Proszę wypełnić ten formularz swoimi danymi',
      property: 'Obiekt *',
      arrivalDate: 'Data przyjazdu *',
      departureDate: 'Data wyjazdu *',
      pointsAwardedTime: 'Punkty zostaną dodane 72 godziny po wymeldowaniu.',
      bookingReferenceNumber: 'Numer rezerwacji *',
      invoiceAmount: 'Kwota rachunku *',
      comment: 'Inne uwagi i wnioski',
      success: 'Twoje zapytanie zostało pomyślnie przesłane.',
    },
    transferPoints: {
      mainTitle: 'punkty transferowe',
      title: 'Ile punktów chciałbyś przekazać?',
      formTitle: 'Konto, na które chciałbyś przelać punkty',
      receiverFirstName: 'Imię *',
      receiverLastName: 'Nazwisko *',
      receiverEmail: 'Adres e-mail*',
      receiverLoyaltyId: 'Numer karty lojalnościowej *',
      allPointsSelection: 'Wszystkie punkty',
      otherAmountSelection: 'Inna kwota',
      pointsAvailable: 'Punkty dostępne: ',
      points2Transfer: 'Punkty do transferu',
      success: 'Twoje zapytanie zostało pomyślnie przesłane.',
    },
    activation: {
      success: [
        'If znaleźliśmy wiadomość e-mail w bazie danych, do której wysłaliśmy Ci link. ',
        'It wygląda na to, że masz już konto. Proszę się zalogować.',
      ],
    },
    reservations: {
      title: 'Rezerwacje',
      property: 'Obiekt',
      check: 'Zameldowanie / Wymeldowanie',
      rate: 'Stawka',
      status: 'Status',
      checkRates: 'Sprawdź stawki',
      noReservations: 'Nie masz nadchodzących rezerwacji',
      newHolidays: 'To czas na Twoje nowe wakacje. ',
      noPropertyTitle: 'Nie znaleziono nazwy nieruchomości. PhobsID: ',
      bookingRef: 'Numer rezerwacji',
      memberRate: 'Całkowita stawka członkowska',
      discoverExperiences: 'Odkryj nowe doświadczenia',
      activeReservations: 'Aktywne rezerwacje',
      pastReservations: 'Wcześniejsze rezerwacje',
    },
  },
  si: {
    all: 'vse',
    filters: 'Filtri',
    clearFilters: 'Počisti filtre',
    applyFilters: 'Uporabi filter',
    showFilters: 'Pokaži filtre',
    closeFilters: 'Zapri filtre',
    destinations: 'Destinacije',
    interests: 'Zanimanja',
    destination: 'Destinacija',
    brands: 'Blagovne znamke',
    types: 'Tip nastanitve',
    starRating: 'Število zvezdic',
    back: 'Nadzorna plošča',
    services: 'Objekti/storitve',
    sortBy: 'Razvrsti po',
    recommendedFirst: 'Razvrsti po priporočenem',
    lowFirst: 'Cena - najprej najnižja',
    highFirst: 'Cena - najprej najvišja',
    lowPointsFirst: 'Točke - najprej najnižje',
    highPointsFirst: 'Točke - najprej najvišje',
    noResults: 'Ni rezultatov, spremenite filter',
    unavailableSeparator: 'Ni na voljo za izbrane datume',
    bookNow: 'Rezervirajte zdaj',
    from: 'od',
    perUnit: 'na enoto',
    error: 'Napaka',
    holidayTypeFilter: 'Vrsta počitnic',
    property: 'Lastnina',
    discoverMore: 'Odkrijte več',
    confirm: 'Potrdi',
    canceled: 'Prekinjeno',
    notCanceled: 'Aktivno',
    formSubmitSuccess: 'Obrazec ste uspešno oddali.',
    loadMore: 'Naloži več',
    results: 'Rezultati:',
    allDestinations: 'Vse destinacije',
    allBrands: 'Vse znamke',
    allInterests: 'Vsi interesi',
    error403: {
      title: '403',
      text: 'Za dostop do te strani morate biti prijavljeni.',
      goHome: 'Domov',
    },
    searchApp: {
      placeholder: 'Iskanje objektov, ponudb, idej ...',
      suggestionsTitle: 'Poišči svoj popoln pobeg',
      showFilters: 'Prikaži filtre',
      clearFilters: 'Počisti vse',
      applyFilters: 'Uporabi filter',
      cancelFilters: 'Prekliči',
      resultType: {
        offer: 'Posebna ponudba',
      },
      filters: {
        propertyType: 'Vrsta objekta',
        destination: 'Destinacija',
        brand: 'Blagovna znamka',
      },
      noResults: 'Za iskani izraz ni rezultatov.',
      showing: 'Prikazujem',
      outOf: 'od',
      results: 'rezultatov',
    },
    focusedSearch: {
      placeholder: 'Poišči svojo nastanitev',
      showAll: 'Prikaži vse',
      properties: 'Nastanitve',
      specialOffers: 'Posebne ponudbe',
      searchFor: 'Išči:',
    },
    bookingWidget: {
      planYourStay: 'Načrtujte svoje bivanje',
      whereAreYouGoing: 'Kam potujete?',
      noResultsTitle: 'Ni zadetkov za iskano besedno zvezo.',
      noResultsMessage: 'Izberite iz ponudbe ali poskusite z drugimi besedami.',
    },
    propertyTypes: {
      hotels: 'Hoteli',
      resorts: 'Resorti',
      camping: 'Kampi',
    },
    campingTypes: {
      pitches: 'Parcele',
      'mobile-homes': 'Mobilne hiške',
      glamping: 'Glamping',
    },
    checkRates: {
      stepTitle1: 'Kam želiš iti?',
      stepTitle2: 'Kateri hotel, letovišče ali kamp?',
      stepTitle3: 'Izberite datume',
      stepTitle4: 'Izberite število gostov',
      checkRatesButton: 'Preverite cene',
      backLabel: 'nazaj',
      closeButtonLabel: 'Zapri',
      allDestinations: 'Izberite vse destinacije',
      allProperties: 'Izberite vse nastanitve na destinaciji',
      allPropertiesInDestination: 'Vse nastanitve na trenutnih destinacijah',
      hotelsResorts: 'Hoteli in letovišča',
      campsites: 'Kampi',
      noProperties: 'Ni objektov za prikaz.',
      serachOverview: 'Pregled iskanja',
      destination: 'Cilj:',
      edit: 'Uredi',
      nights: 'noči',
    },
    offers: {
      nrOfAvailable: 'ponudbe, ki so na voljo za vaše iskanje',
      titleNoAvailable: 'Za vaše iskanje ni na voljo posebnih ponudb.',
      titleNoAvailableVariants: 'Posebna ponudba je potekla. Spodaj preverite naše aktivne ponudbe',
      subtitleNoAvailable: 'Priporočamo naslednje alternative:',
      recommendedOffers: 'Priporočene posebne ponudbe',
      minimumStayPrefix: 'Minimalno število nočitev:',
      period: 'Obdobje:',
      filter: 'Filtriranje ponudb',
      allHolidays: 'Vse počitnice',
      allProperties: 'Vse namestitve',
      from: 'Od',
      upTo: 'Do',
      recommended: 'Priporočeno za vas',
      popularNow: 'Priljubljeno ta trenutek',
      allOffers: 'Vse ponudbe',
    },
    newsletter: {
      firstName: 'Ime *',
      lastName: 'Priimek *',
      titleAll: 'Ga./G.',
      titleMr: 'G.',
      titleMrs: 'Ga.',
      email: 'E-naslov *',
      gender: 'Pozdrav *',
      birthDate: 'Datum rojstva',
      country: 'Država',
      brands: 'Vrste namestitve *',
      language: 'Jezik e-časopisa *',
      consent: 'Obveščajte me o novicah, ponudbah in ekskluzivnih ponudbah za člane.',
      info: 'Spoštujemo vašo zasebnost in zavezani smo k zaščiti vaših osebnih podatkov. ' +
      'Za več informacij o zaščiti vaših osebnih podatkov glejte našo {privacyPolicy}',
      privacyPolicy: 'Politika o zasebnosti',
      register: 'Registriraj se',
      submitSuccess: 'Obrazec je uspešno oddan.',
    },
    contact: {
      title: 'Kontaktni obrazec',
      subtitle: 'Svoje sporočilo ali vprašanje nam lahko pošljete tudi preko kontaktnega obrazca. Odgovorili vam bomo v najkrajšem možnem času.',
      name: 'Ime in priimek*',
      email: 'Email naslov*',
      subject: 'Zadeva*',
      property: 'Lastnina',
      message: 'Tvoje sporočilo',
      send: 'Pošlji',
      requiredFields: '* Zahtevana polja',
      submitSuccess: 'Obrazec je uspešno oddan.',
    },
    interestsTab: {
      title: 'Moji interesi',
      brand: 'Blagovna znamka',
      destination: 'Destinacija',
      holiday: 'Vrsta počitnic in zanimanja',
      campsite: 'Kamp',
      leadText: 'Vpišite svoja zanimanja za potovanja.',
      dataProtection: '<p>Spoštujemo vašo zasebnost in smo zavezani k zaščiti vaših osebnih podatkov. O vas zbiramo različne vrste osebnih podatkov, kar je odvisno od vašega razmerja z nami in storitev, ki jih uporabljate. V vsakem primeru pa vaše osebne podatke zbiramo in obdelujemo v zakonite namene in v skladu z veljavno pravno podlago.</p><p>Za več informacij o zaščiti vaših osebnih podatkov glejte naše <a href="/si/politika-zasebnosti/">Obvestilo o zasebnosti</a>.</p>',
      updateSuccess: 'Uspešno ste posodobili svoja zanimanja.',
    },
    preferencesTab: {
      title: 'Izbire',
      leadText: 'Upoštevajte, da vse možnosti niso splošno na voljo v vseh objektih in ob vsakem času.',
      bedding: 'Želje glede vzglavnikov in posteljnine',
      notAvailableInCampsites: '*Ni na voljo v vseh kampih.',
      rooms: 'Izbire sobe',
      roomsExtra: 'Na podlagi razpoložljivosti v odvisnosti od hotela in vrste sobe, ki ste jo rezervirali.',
      services: 'Dodatne storitve',
      servicesExtra: 'Brezplačno, na voljo samo v določenih objektih.',
      food: 'Izbira hrane',
      childEquipment: 'Dodatna oprema za dojenčke in otroke (brezplačno)',
      pickupAtReception: '*Prevzamete na hotelski recepciji',
      typeHere: 'vnesite tukaj',
      updateSuccess: 'Uspešno ste posodobili svoje preference.',
    },
    extraServices: {
      title: 'Dodatne storitve (ob doplačilu) ',
      text: 'Ali imate dodatne zahteve za hotel?',
      footer: 'npr. baloni, torta, rože ali pijača v sobi',
    },
    activity: {
      activity: 'dejavnost',
      youHave: 'imaš:',
      expiration: 'DATUM poteka veljavnosti.. imamo to?',
      transferPoints: 'Točke za prenos',
      missingPoints: 'pridobi manjkajoče točke',
      pointsActivity: 'Aktivnosti zbiranja točk',
      date: 'Datum',
      source: 'Vir',
      points: 'Točke',
      noActivity: 'Trenutno ni dejavnosti točk.',
      title: 'Aktivnosti zbiranja točk',
      transactionTypes: ['Bivanje', 'Anketa', 'Registracija', 'Stik urejen', 'Prenos točk', 'Drugo', 'Zahteva za točke', 'Unovčenje točk', 'Poteklo', 'Poraba izven penziona'],
    },
    activityPointsCommon: {
      requiredFields: '* Ta polja so obvezna',
      send: 'Pošlji',
    },
    awards: {
      all: 'vse',
      recommended: 'Priporočene nagrade',
      title: 'MaiStar nagrade',
      recommendedTitle: 'Priporočene nagrade za vaše naslednje bivanje',
      points: 'točke',
      discoverMore: 'Odkrijte več',
      available: 'Na voljo',
      unavailable: 'Ni na voljo',
      noReservations: 'Nimate prihodnjih rezervacij. Čas je za vaše nove počitnice.',
    },
    dashboard: {
      title: 'Nadzorna plošča',
      welcome: 'Dobrodošli',
      displayName: 'Prikazno ime',
      level: 'Raven',
      editprofile: 'Uredi profil',
      membershipNumber: 'Članska številka',
      memberSince: 'Član od',
      viewPoints: 'Ogled aktivnosti točk',
      viewBookings: 'ogled vseh rezervacij',
      viewProperties: 'view all properties',
      enlargeQr: 'Povečaj QR kodo',
      youHave: 'Imaš',
      points: 'točke',
      myBookings: 'Moje rezervacije',
      maiFamilyProperties: 'Recommended properties',
      rewards: 'Nagrade',
      maistarRewards: 'MaiStar nagrade',
      viewRewards: 'oglejte si vse nagrade',
      noRewards: 'brez nagrad',
      moreAboutStatus: 'Več o vašem statusu',
      scrollDown: 'Pomaknite navzdol',
      expiresOn: 'Poteče:',
      personalDetails: 'Osebni podatki',
      addToAppleWallet: 'Dodaj v Apple Wallet',
      addToGoogleWallet: 'Dodaj v Google Wallet',
    },
    obtainPoints: {
      mainTitle: 'Pridobite manjkajoče točke',
      title: 'Manjkajo točke za rezervacijo?<br>Pošljite zahtevo za manjkajoče točke.',
      formTitle: 'Prosimo, izpolnite ta obrazec s svojimi podatki',
      property: 'Nepremičnina *',
      arrivalDate: 'Datum prihoda *',
      departureDate: 'Datum odhoda *',
      pointsAwardedTime: 'Točke bodo dodane 72 ur po odjavi.',
      bookingReferenceNumber: 'Referenčna številka rezervacije *',
      invoiceAmount: 'Znesek računa *',
      comment: 'Drugi komentarji in prošnje',
      success: 'Vaša zahteva je bila uspešno poslana.',
    },
    transferPoints: {
      mainTitle: 'Točke za prenos',
      title: 'Koliko točk želite prenesti?',
      formTitle: 'Račun, na katerega želite prenesti točke',
      receiverFirstName: 'Ime *',
      receiverLastName: 'Priimek *',
      receiverEmail: 'Email naslov *',
      receiverLoyaltyId: 'Številka kartice zvestobe *',
      allPointsSelection: 'Vse točke',
      otherAmountSelection: 'Drugi znesek',
      pointsAvailable: 'Na voljo točke:',
      points2Transfer: 'Točke za prenos:',
      success: 'Vaša zahteva je bila uspešno poslana.',
    },
    activation: {
      success: ['Če smo našli e-pošto v bazi podatkov, smo vam poslali povezavo.', 'Kaže, da že imate račun. Prosimo, prijavite se.'],
    },
    reservations: {
      title: 'Rezervacije',
      property: 'Lastnina',
      check: 'Prijava odjava',
      rate: 'Oceniti',
      status: 'Stanje',
      checkRates: 'Preverite cene',
      noReservations: 'Nimate prihodnjih rezervacij.',
      newHolidays: 'Čas je za vaše nove počitnice.',
      noPropertyTitle: 'Ime objekta ni bilo najdeno. PhobsID:',
      bookingRef: 'Ref. rezervacije:',
      memberRate: 'Skupna stopnja članov',
      discoverExperiences: 'Odkrijte nove izkušnje',
      activeReservations: 'Aktivne rezervacije',
      pastReservations: 'Pretekle rezervacije',
    },
  },
}

export {
  messagesSpecific,
}
